import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ErrorMessageService } from './error-message.service';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError =
  <T> (operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {

  constructor(
    
    private errorMsgHandlerService: ErrorMessageService
  ) { }

  /** Create curried handleError function that already knows the service name */
  createHandleError = (serviceName = '') => <T>
    (operation = 'operation', result = {} as T) => this.handleError(serviceName, operation, result);

  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {

    return (error: HttpErrorResponse): Observable<T> => {

      const message = (error.error instanceof ErrorEvent) ?
        error.error.message :
        `server returned code ${error.status} with body "${error.error}"`;
      
        // log to console instead
      console.error("Http error occured in ::  "
        + serviceName
        + ":  " + operation
        + ":  " + message);

        // if (error instanceof HttpErrorResponse) {
        //   if (error.error instanceof ErrorEvent) {
        //     console.error("Error Event");
        //   } else {
        //     console.log(`error status : ${error.status} ${error.message}`);
        //     switch (error.status) {
        //       case 401:      //login
        //         this.oktaAuth.loginRedirect('/');
        //         break;
        //       case 403:     //forbidden
        //         console.log('unauthorized');
        //         // this.router.navigateByUrl("/unauthorized");
        //         break;
        //     }
        //   } 
        // } 
        //else {
        //   console.error("some thing else happened");
        // }


      //this.errorMsgHandlerService.add(`${serviceName}: ${operation} failed: ${message}`);

      // Let the app keep running by returning a safe result.
      return of(result);
    };

  }
}
